module.exports = __webpack_public_path__ + "media/luxury-2026/formal-drone-960-68aa2530.jpg";